import { render, staticRenderFns } from "./EditGR.vue?vue&type=template&id=e6e87994&"
import script from "./EditGR.vue?vue&type=script&lang=js&"
export * from "./EditGR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports